export class Rfs__packages{

    static PackageCardTitle(){};

    static PageContent(){};

}
